import { grid } from '@shared/styles';

export const PLAN_DESCRIPTION_HEIGHT = grid(28);
export const BREAKDOWN_ITEM_HEIGHT = grid(8);
